import styled from "styled-components/macro"
import { Input, MultilineInput } from "@humanpredictiveintelligence/myqvt-library"

export const Container = styled.div`
  padding: 12px 24px;
  background-color: white;
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Form = styled.div<{ $isLoading?: boolean }>`
  display: flex;
  gap: 30px;
`

export const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1
`

export const NameInput = styled(Input)`
  width: 100%;
  
  label {
    font-size: 12px;
  }
`

export const DescriptionInput = styled(MultilineInput)`
  textarea {
    width: 100%;
  }
`
